import { IFont } from './IFont';

export const AWS_ACCESS_KEY = 'AKIAYK2L5QAH7MZWZSVC';
export const AWS_SECRET_ACCESS_KEY = '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';

export const ET_PIPELINE = '1511942426591-tpw744';
export const ET_PRESET_STANDARD = '1549878730625-eadzyh'; // was '1512388962432-18jwu6';
export const ET_PRESET_GIF = '1526293980995-juo77f';

export const S3_BUCKET_NAME = 'beatflyer-test';
export const S3_BUCKET_REGION = 'eu-west-1';

export const MAX_MUSIC_DURATION_WEB_SECONDS = 1.5 * 60;
export const MAX_CAPTIONS_DURATION = 90;
export const MAX_LAMBDA_VIDEO_SIZE = 200 * 1000 * 1000;

export const INTRO_STORAGE_KEY = 'INTRO_STORAGE_KEY';
export const ADDED_EFFECT_STORAGE_KEY = 'ADDED_EFFECT_STORAGE_KEY';
export const DONT_PROMPT_NEW_OPAQUE_LAYER_SPLIT =
  'DONT_PROMPT_NEW_OPAQUE_LAYER_SPLIT';
export const SCALED_UP_ALERT_STORAGE_KEY = 'SCALED_UP_ALERT_STORAGE_KEY';

export const DEFAULT_BPM = 80;
export const MAX_FRAMES_AMOUNT = 15;

export const DEFAULT_VIDEO_DURATION = 15000; // 3 seconds
export const VIDEO_DURATION_OPTIONS = [
  5000,
  8000,
  DEFAULT_VIDEO_DURATION,
  30000,
  45000,
  90000
];
export const GIF_FPS = 15;
export const VIDEO_FPS = 30;

export const INPUT_WIDGET_WIDTH = 150;
export const VIDEO_EFFECTS_FADE_IN_OUT_DURATION = 500;

export const COST_PER_DAY = 3;
export const COST_PER_MONTH = 10;
export const COST_PER_YEAR = 60;

export const ACCEPTABLE_FRAMES_RECORDED = 0.9;
export const REFERRER_STORAGE_KEY = 'referrer';
export const TOUR_POSITION_STORAGE_KEY = 'TOUR_POSITION';
export const LOG_STATUS_STORAGE_KEY = 'LOG_STATUS_STORAGE_KEY';
export const TRANSCRIBE_LANGUAGE_STORAGE_KEY = 'TRANSCRIBE_LANGUAGE';
export const EXTERNAL_SEGMENTATION_SURVEY_STORAGE_KEY =
  'EXTERNAL_SEGMENTATION_SURVEY';

export const RENDERER_EMAIL = 'renderer@beatflyer.com';

export const INITIAL_FONT: IFont = {
  label: 'Open Sans Regular',
  family: 'Open Sans',
  weight: 400
};
export const AVAILABLE_FONTS: IFont[] = [
  { label: 'Arvo Regular', family: 'Arvo', weight: 400 },
  { label: 'Arvo Bold', family: 'Arvo', weight: 700 },
  { label: 'BioRhyme Regular', family: 'BioRhyme', weight: 400 },
  { label: 'BioRhyme Bold', family: 'BioRhyme', weight: 700 },
  { label: 'BioRhyme Extra Bold', family: 'BioRhyme', weight: 800 },
  { label: 'Bitter Regular', family: 'Bitter', weight: 400 },
  { label: 'Bitter Bold', family: 'Bitter', weight: 700 },
  { label: 'Comfortaa Regular', family: 'Comfortaa', weight: 400 },
  { label: 'Comfortaa Bold', family: 'Comfortaa', weight: 700 },
  { label: 'Copse', family: 'Copse', weight: 400 },
  {
    label: 'Cormorant Garamond Bold',
    family: 'Cormorant Garamond',
    weight: 700
  },
  { label: 'Cutive', family: 'Cutive', weight: 400 },
  { label: 'Dynalight', family: 'Dynalight', weight: 400 },
  { label: 'Gravitas One', family: 'Gravitas One', weight: 400 },
  { label: 'Kavoon', family: 'Kavoon', weight: 400 },
  {
    label: 'Libre Baskerville Regular',
    family: 'Libre Baskerville',
    weight: 400
  },
  { label: 'Libre Baskerville Bold', family: 'Libre Baskerville', weight: 700 },
  { label: 'Lora Regular', family: 'Lora', weight: 400 },
  { label: 'Lora Medium', family: 'Lora', weight: 500 },
  { label: 'Lora Semi Bold', family: 'Lora', weight: 600 },
  { label: 'Lora Bold', family: 'Lora', weight: 700 },
  { label: 'Lora Italic Regular', family: 'Lora:italic', weight: 400 },
  // { label: 'Lora Italic Medium', family: 'Lora:italic', weight: 500 },
  // { label: 'Lora Italic Semi Bold', family: 'Lora:italic', weight: 600 },
  { label: 'Lora Italic Bold', family: 'Lora:italic', weight: 700 },
  { label: 'Monoton', family: 'Monoton', weight: 400 },
  { label: 'Montserrat Extra Bold', family: 'Montserrat', weight: 800 },
  { label: 'MuseoModerno Regular', family: 'MuseoModerno', weight: 400 },
  { label: 'MuseoModerno Bold', family: 'MuseoModerno', weight: 700 },
  { label: 'Neuton Medium', family: 'Neuton', weight: 500 },
  { label: 'Neuton Bold', family: 'Neuton', weight: 700 },
  { label: 'Neuton Extra Bold', family: 'Neuton', weight: 800 },
  { label: 'Nunito Regular', family: 'Nunito', weight: 400 },
  { label: 'Nunito Medium', family: 'Nunito', weight: 500 },
  { label: 'Nunito Semi Bold', family: 'Nunito', weight: 600 },
  { label: 'Nunito Bold', family: 'Nunito', weight: 700 },
  { label: 'Nunito Extra Bold', family: 'Nunito', weight: 800 },
  { label: 'Nunito Black', family: 'Nunito', weight: 900 },
  { label: 'Open Sans Regular', family: 'Open Sans', weight: 400 },
  { label: 'Open Sans Semi Bold', family: 'Open Sans', weight: 600 },
  { label: 'Open Sans Bold', family: 'Open Sans', weight: 700 },
  { label: 'Open Sans Extra Bold', family: 'Open Sans', weight: 800 },
  {
    label: 'Open Sans Condensed Light',
    family: 'Open Sans Condensed',
    weight: 300
  },
  {
    label: 'Open Sans Condensed Bold',
    family: 'Open Sans Condensed',
    weight: 700
  },
  { label: 'Pacifico', family: 'Pacifico', weight: 400 },
  { label: 'Playball', family: 'Playball', weight: 400 },
  { label: 'Quicksand Medium', family: 'Quicksand', weight: 500 },
  { label: 'Quicksand Semi Bold', family: 'Quicksand', weight: 600 },
  { label: 'Quicksand Bold', family: 'Quicksand', weight: 700 },
  { label: 'Roboto Regular', family: 'Roboto', weight: 400 },
  { label: 'Roboto Medium', family: 'Roboto', weight: 500 },
  { label: 'Roboto Bold', family: 'Roboto', weight: 700 },
  { label: 'Roboto Black', family: 'Roboto', weight: 900 },
  { label: 'Rubik Regular', family: 'Rubik', weight: 400 },
  { label: 'Rubik Medium', family: 'Rubik', weight: 500 },
  { label: 'Rubik Bold', family: 'Rubik', weight: 700 },
  { label: 'Rubik Black', family: 'Rubik', weight: 900 },
  { label: 'Sanchez', family: 'Sanchez', weight: 400 },
  { label: 'Slabo', family: 'Slabo 13px', weight: 400 },
  { label: 'Slabo Condensed', family: 'Slabo 27px', weight: 400 },
  { label: 'Scope One', family: 'Scope One', weight: 400 },
  { label: 'Trocchi', family: 'Trocchi', weight: 400 },
  { label: 'Vesper Libre Regular', family: 'Vesper Libre', weight: 400 },
  { label: 'Vesper Libre Medium', family: 'Vesper Libre', weight: 500 },
  { label: 'Vesper Libre Bold', family: 'Vesper Libre', weight: 700 },
  { label: 'Vesper Libre Black', family: 'Vesper Libre', weight: 900 },
  { label: 'Zilla Slab Highlight', family: 'Zilla Slab Highlight', weight: 400 }
];



// WEBPACK FOOTER //
// ./src/data/Config.ts